const API_BASE_URL = 'https://cpos.chosenstore.in';
document.addEventListener('click', function (event) {
  // Save for Later button
  if (event.target.classList.contains('btn')) {
    const button = event.target;

    const customerId = button.getAttribute('data-customer-id');
    const productId = button.getAttribute('data-product-id');
    const productHandle = button.getAttribute('data-product-handle');
    const productGid = button.getAttribute('data-product-gid');
    const variantId = button.getAttribute('data-variant-id');
    const price = button.getAttribute('data-price-id');

    if (!customerId || !productId || !productHandle) {
      console.error('Missing data attributes');
      return;
    }

    const formData = new FormData();
    formData.append('customer_id', customerId);
    formData.append('product_id', productId);
    formData.append('product_handle', productHandle);
    formData.append('product_gid', productGid);
    formData.append('variant_id', variantId);
    formData.append('price', price);

    fetch(`${API_BASE_URL}/api/save-for-later`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.success || data.message) {
          console.log("Product save response received");
          const savedContainer = document.getElementById('saved-products-container');
          const savedHeading = document.getElementById('saved-products-heading');

          if (data.saved_count && savedHeading) {
            savedHeading.innerHTML = `Save For Later <span class="cart-drawer__item-qty">${data.saved_count} product${data.saved_count > 1 ? 's' : ''}</span>`;
            // savedHeading.textContent = `Save For Later (${data.saved_count} product${data.saved_count > 1 ? 's' : ''})`;
          }

          // Only insert if new product was saved
          if (savedContainer && Array.isArray(data.data) && data.data.length > 0) {
            const newProduct = data.data[0];

            const alreadyExists = savedContainer.querySelector(
              `[data-product-id="${newProduct.product_id}"][data-variant-id="${newProduct.variant_id}"]`
            );

            if (alreadyExists) {
              showFlashMessage('This product is already in your saved list.');
              return;
            }

            const savedItem = document.createElement('div');
            savedItem.className = 'saved-product';
            savedItem.setAttribute('data-product-id', newProduct.product_id);
            savedItem.setAttribute('data-variant-id', newProduct.variant_id);
            savedItem.innerHTML = `
              <div class="cart__item cart__itemAdd"> 
                <div class="cart__item__image">
                    <a href="/products/${newProduct.product_handle}">
                      <figure class="lazy-image lazy-image--cover">
                        <img src="${button.getAttribute('data-product-image') || ''}" alt="${button.getAttribute('data-product-title') || ''}" />
                      </figure>
                    </a>
                </div>
                <div class="cart__item__content">
                  <div class="cart__item__content-inner"> 
                    <div class="cart__item__info">
                      <p class="cart__item__title">${button.getAttribute('data-product-title') || 'No Title'}</p>
                    </div>
                    <p class="cart__item__price">${button.getAttribute('data-price-id') || '0.00'}</p>
                  </div>
                  <form method="post" action="/cart/add" class="quick__form" accept-charset="UTF-8" enctype="multipart/form-data">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="quantity" value="1">
                    <input type="hidden" name="id" value="${newProduct.variant_id}">
                    <input type="hidden" name="product-id" value="${newProduct.product_id}">
                    <button type="submit" class="custom-to-cart btn--quick rounded">
                      <span class="btn__inner">
                       <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-shopping-bag" viewBox="0 0 192 192">
                            <path d="M156.6 162H35.4a6.075 6.075 0 0 1-6-5.325l-10.65-96A6 6 0 0 1 24.675 54h142.65a6.001 6.001 0 0 1 5.925 6.675l-10.65 96a6.076 6.076 0 0 1-6 5.325v0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M66 78V54a30 30 0 1 1 60 0v24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <circle class="cart-indicator" cx="96" cy="108" r="15"></circle>
                          </svg>
                        <span class="btn__text">Add to Cart</span>
                      </span>
                    </button>
                  </form>
                  <button class="cart__item__remove remove-saved" data-product-id="${newProduct.product_id}">Remove</button>
                </div>
              </div>
            `;
            savedContainer.insertBefore(savedItem, savedContainer.firstChild);
            if (savedHeading) savedHeading.style.display = 'block';
          } else {
            showFlashMessage('This product is already in your saved list.');
          }

          // Remove from Shopify cart
          const cartItem = button.closest('.cart__item');
          if (cartItem) {
            const lineItemKey = cartItem.getAttribute('data-item');
            cartItem.remove();

            if (lineItemKey) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
              })
                .then(res => res.json())
                .then(data => console.log('Shopify cart updated', data))
                .catch(err => console.error('Error removing from Shopify cart', err));
            }
          }
        } else {
          console.log("Failed to save product");
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
  }

  // Add to Cart from Saved
  if (event.target.closest('.custom-to-cart')) {
    event.preventDefault();

    const button = event.target.closest('.custom-to-cart');
    const form = button.closest('form');
    const variantId = form.querySelector('input[name="id"]')?.value;
    const productId = form.querySelector('input[name="product-id"]')?.value;
    const customerId = document.body.getAttribute('data-customer-id');
    const savedItem = button.closest('.saved-product');

    if (!variantId) {
      alert('Missing variant ID');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(res => res.json())
      .then(data => {
        console.log('Added to cart:', data);

        // Remove from saved list
        if (customerId && productId) {
          fetch(`${API_BASE_URL}/api/save-for-later/${customerId}/${productId}`, {
            method: 'DELETE',
          })
            .then(res => res.json())
            .then(deleteData => {
              console.log('Deleted from Save for Later');
              if (savedItem) savedItem.remove();

              const heading = document.getElementById('saved-products-heading');
              if (heading) {
                if (deleteData.saved_count && deleteData.saved_count > 0) {
                    heading.innerHTML = `Save For Later <span class="cart-drawer__item-qty">${deleteData.saved_count} products</span>`;
                    // heading.innerHTML = `Save For Later erer<span>(${deleteData.saved_count} products)</span>`;
                  heading.style.display = 'block';
                } else {
                  heading.style.display = 'none';
                }
              }
            })
            .catch(err => console.error('Delete error:', err));
        }
      })
      .catch(err => {
        console.error('Add to cart error:', err);
      });
  }

  // Remove button from Saved
  if (event.target.classList.contains('remove-saved')) {
    const customerId = document.body.getAttribute('data-customer-id');
    const productId = event.target.getAttribute('data-product-id');
    const savedItem = event.target.closest('.saved-product');

    if (!customerId || !productId || !savedItem) return;

    fetch(`${API_BASE_URL}/api/save-for-later/${customerId}/${productId}`, {
      method: 'DELETE',
    })
      .then(res => res.json())
      .then(data => {
        savedItem.remove();
        const heading = document.getElementById('saved-products-heading');

        if (data.saved_count && heading) {
              heading.innerHTML = `Save For Later <span class="cart-drawer__item-qty">${data.saved_count} products</span>`;
          heading.style.display = 'block';
        } else if (heading) {
          heading.style.display = 'none';
        }

        const remainingItems = document.querySelectorAll('.saved-product');
        if (remainingItems.length === 0 && heading) {
          heading.style.display = 'none';
        }
      })
      .catch(err => {
        console.error('Error deleting saved product', err);
      });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  loadSavedForLaterProducts();
  document.addEventListener('theme:cart:open', function () {
    console.log('Cart drawer open!');
    console.log('DOM fully loaded');
    loadSavedForLaterProducts();
  });
});

function formatPrice(product_price) {
  const amount = parseFloat(product_price || 0);
  return `Rs. ${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function showFlashMessage(message) {
  const flashMsg = document.querySelector('.freeShiping_msg');
  if (!flashMsg) return;
  flashMsg.textContent = message;
  flashMsg.style.display = 'block';
  setTimeout(() => {
    flashMsg.style.display = 'none';
  }, 4000);
}
function loadSavedForLaterProducts() {
  const customerId = document.body.getAttribute('data-customer-id');
  if (!customerId) return;

  console.log('Customer ID:', customerId);

  setTimeout(() => {
    fetch(`${API_BASE_URL}/api/save-for-later/${customerId}`)
      .then(res => res.json())
      .then(data => {
        const container = document.getElementById('saved-products-container');
        const heading = document.getElementById('saved-products-heading');
        if (!container || !data.data) return;

        container.innerHTML = ''; // Clear old content

        if (data.count && heading) {
          heading.innerHTML = `Save For Later <span class="cart-drawer__item-qty">${data.count} products</span>`;
          heading.style.display = 'block';
        } else if (heading) {
          heading.style.display = 'none';
        }

        data.data.forEach(product => {
          const savedItem = document.createElement('div');
          savedItem.className = 'saved-product';

          savedItem.innerHTML = `
            <div class="cart__item cart__itemAdd"> 
              <div class="cart__item__image">
                <a href="/products/${product.product_handle}">
                  <figure class="lazy-image lazy-image--cover">
                    <img src="${product.product_image || ''}" alt="${product.product_title || ''}" />
                  </figure>
                </a>
              </div>

              <div class="cart__item__content">
                <div class="cart__item__content-inner"> 
                  <div class="cart__item__info">
                    <p class="cart__item__title">${product.product_title || 'No Title'}</p>
                  </div>
                  <p class="cart__item__price">${formatPrice(product.product_price)}</p>
                </div>
                <form method="post" action="/cart/add" class="quick__form" accept-charset="UTF-8" enctype="multipart/form-data" data-product-form="" data-quickbuy-form="">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="quantity" value="1">
                  <input type="hidden" name="id" value="${product.variant_id}">
                  <button type="submit" name="add" class="custom-to-cart btn--quick rounded " data-add-to-cart tabindex="0">
                    <span class="btn__inner">
                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-shopping-bag" viewBox="0 0 192 192">
                        <path d="M156.6 162H35.4a6.075 6.075 0 0 1-6-5.325l-10.65-96A6 6 0 0 1 24.675 54h142.65a6.001 6.001 0 0 1 5.925 6.675l-10.65 96a6.076 6.076 0 0 1-6 5.325v0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M66 78V54a30 30 0 1 1 60 0v24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                        <circle class="cart-indicator" cx="96" cy="108" r="15"></circle>
                      </svg>
                      <span class="btn__text">Add to Cart</span>
                      <span class="btn__loader">
                        <svg height="18" width="18" class="svg-loader">
                          <circle r="7" cx="9" cy="9"></circle>
                          <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                        </svg>
                      </span>
                    </span>
                  </button>
                  <div class="product-grid-item__error" role="alert" data-cart-errors-container=""></div>
                  <input type="hidden" name="product-id" value="${product.product_id}">
                </form>
                <button class="cart__item__remove remove-saved" data-product-id="${product.product_id}">Remove</button>
              </div>
            </div>
          `;

          container.appendChild(savedItem);
        });
      })
      .catch(err => console.error('Fetch Error:', err));
  }, 2000);
}
